import { ConceptualLabelScopes } from '../../constants/conceptual-label-scopes'
import baseApi from './base.api'
import { normalizeFetchDisciplinesResponse } from './utils/normalizers/discipline.normalizers'
import { DISCIPLINE_TAG } from './utils/tags'

export const disciplineApi = baseApi.injectEndpoints({
    endpoints: builder => ({
        fetchDisciplines: builder.query({
            query: (options = {}) => {
                const { scope = ConceptualLabelScopes.ALL } = options || {}
                return {
                    url: '/disciplines',
                    method: 'GET',
                    params: { scope }
                }
            },
            providesTags: [DISCIPLINE_TAG],
            transformResponse: normalizeFetchDisciplinesResponse,
        }),
        createDiscipline: builder.mutation({
            query: ({ name, description }) => ({
                url: '/disciplines',
                method: 'POST',
                body: { name, description },
            }),
            invalidatesTags: [DISCIPLINE_TAG],
        }),
        updateDiscipline: builder.mutation({
            query: ({ id, name, description }) => ({
                url: `/disciplines/${id}`,
                method: 'PATCH',
                body: { name, description },
            }),
            invalidatesTags: (result, error, { id }) => [{ type: DISCIPLINE_TAG, id }, DISCIPLINE_TAG],
        }),
        deleteDiscipline: builder.mutation({
            query: id => ({
                url: `/disciplines/${id}`,
                method: 'DELETE',
            }),
            invalidatesTags: [DISCIPLINE_TAG],
        }),
    }),
})

export const {
    useFetchDisciplinesQuery,
    useCreateDisciplineMutation,
    useUpdateDisciplineMutation,
    useDeleteDisciplineMutation,
} = disciplineApi
